import { render } from "./NxgAdvWidget.vue?vue&type=template&id=4ba5bbf4"
import script from "./NxgAdvWidget.vue?vue&type=script&lang=js"
export * from "./NxgAdvWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__